import React from "react";
import MobilePageLayout from "../components/MobilePageLayout";
import StepProgress from "../components/StepProgress";

const HomePage = ({ onNext }) => {
  return (
    <MobilePageLayout ctaLabel="Next" onCtaClick={() => onNext(null)}>
      <img src="/logo.png" className="logo" alt="LOKRAM" />

      <StepProgress current={1} />
      <h2 className="page-title">Instructions</h2>

      <ol className="instructions">
        <li>Call owner and keep <b>Box Code</b> and <b>Unlock Pin</b> ready</li>
        <li>Ensure Bluetooth is enabled</li>
        <li>Login with your phone number</li>
        <li>Enter OTP, name, and email</li>
        <li>Pair with the Bluetooth lock</li>
        <li>Select lock named with <b>Box Code</b></li>
        <li>Enter <b>Unlock Pin</b></li>
        <li>Place items and close door firmly</li>
      </ol>
    </MobilePageLayout>
  );
};

export default HomePage;
